<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动礼包ICON配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:actIconSort:add']" size="mini" type="primary" @click="dialogVisible = true">添加等级</el-button>
            <el-button v-permisaction="['config:actIconSort:exportJson']" size="mini" type="primary" @click="exportJson">导出JSON</el-button>
            <syncVersion :in-method="IconAsyncOss" :params="params" />
            <!--            <el-button v-permisaction="['config:actIconSort:asyncOss']" type="primary" @click="asyncOss">同步OSS</el-button>-->
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 200px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 200px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <!--              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>-->
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-form-item label="右边展示数量">
                            <el-input v-model.number="scoreItem.group_bak" style="width: 200px;" placeholder="位置" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}" />
                          </el-form-item>
                        </el-form>
                      </div>
                      <el-table :data="scoreItem.data" border stripe>
                        <el-table-column prop="tips" label="活动icon类型">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.tips" filterable disabled placeholder="请选择">
                              <el-option
                                v-for="item in actType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="isShow" label="是否展示">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.isShow" style="width: 120px;" placeholder="请选择">
                              <el-option
                                v-for="item in isShowType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="buyNum" label="是否限时按钮">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.isShowBtn" style="width: 120px;" placeholder="请选择">
                              <el-option
                                v-for="item in isShowType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="iconWeight" label="ICON权重">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.iconWeight" />
                          </template>
                        </el-table-column>
                        <el-table-column prop="position" label="位置">
                          <template slot-scope="scope">
                            <el-select v-model.number="scope.row.position" placeholder="请选择">
                              <el-option
                                v-for="item in positionArr"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column prop="propsWeight" label="道具权重">
                          <template slot-scope="scope">
                            <el-input v-model.number="scope.row.propsWeight" />
                          </template>
                        </el-table-column>

                      </el-table>
                      <el-button v-if="scoreItem.data.length <= 0" v-permisaction="['config:actIconSort:add']" type="primary" @click="addRecord(tabItem.label,scoreItem.group_name)">+</el-button>
                      <el-button v-permisaction="['config:actIconSort:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                      <el-button v-permisaction="['config:actIconSort:del']" style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name,scoreItem.data[0].id)">删除</el-button>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import {
  delActIconSortCfgList,
  getActIconSortCfgList,
  updateActIconSortCfg,
  getIconTypes,
  IconAsyncOss
} from '@/api/config/act-icon-sort-cfg'
import SyncVersion from '@/components/SyncVersion/index.vue'
export default {
  name: 'ActivitySortIcon',
  components: { SyncVersion },
  data() {
    return {
      params: { name: 'IconConfig' },
      key: 'IconConfig',
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      rewardType: [],
      isShowType: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ],
      positionArr: [{ label: '右', value: 0 }, { label: '左', value: 1 }],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: 0,
        group_name: '',
        group_bak: 0,
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      actType: [],
      actTypes: {},
      actTypeArr: []
    }
  },
  created() {
    this.getActTypes()
    this.getTables()
  },
  methods: {
    IconAsyncOss,
    onSubmit(noTips = false) {
      // const data = JSON.stringify(this.formData)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: [parseInt(scoreItem.group)]
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data
          _data.stage = key
          _postData.push({
            level_min: parseInt(minLevel),
            level_max: parseInt(maxLevel),
            list: _data,
            stage: key,
            rightMaxShow: scoreItem.group
          })
        }
      }

      // console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      // console.log(postCondition)
      // console.log(_postData)
      updateActIconSortCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, levelName, scoreName, index) {
      this.visibleArr[levelName][scoreName][index].visible = false
    },
    load() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return loading
    },
    getTables(actName) {
      // const loading = this.load()
      this.formData = []
      this.tabPane = []
      getActIconSortCfgList().then(res => {
        if (res.code === 200) {
          const data = res.data.data
          // const tab = {}
          const cond = res.data.cond
          for (const i in cond) {
            const val = cond[i]
            const levelName = val.start + '-' + val.end
            const scoreName = val.groups.join('-')

            // 初始化弹窗
            // if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            //   this.$set(this.visibleArr, levelName, {})
            // }

            // eslint-disable-next-line no-unused-vars
            if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
              this.$set(this.formData, levelName, {})
              this.$set(this.actTypes, levelName, {})
            }

            // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
            //   this.$set(this.formData[levelName][scoreName], 'data', [])
            // }

            this.$set(this.formData[levelName], scoreName, {
              'group': val.groups[0],
              'group_name': scoreName,
              'group_bak': val.groups[0],
              data: []
            })

            this.$set(this.actTypes[levelName], scoreName, this.actType)

            for (const ii in data) {
              const _event = data[ii]
              if (_event.stage === i) {
                _event.list.forEach(item => {
                  if (this.actTypeArr.includes(item.id)) {
                    let name = item.tips
                    for (const i in this.actType) {
                      if (this.actType[i].value == item.id) {
                        name = this.actType[i].label
                      }
                    }
                    item.tips = name
                    this.formData[levelName][scoreName].data.push(item)
                  }
                })

                const diffArr = this.diffArray(this.formData[levelName][scoreName].data)
                for (const i in this.actType) {
                  const actType = this.actType[i]
                  if (diffArr.includes(parseInt(actType.value))) {
                    this.formData[levelName][scoreName].data.push({
                      iconWeight: 0,
                      id: actType.value,
                      isShow: 0,
                      isShowBt: 0,
                      isShowCountdown: 0,
                      position: 0,
                      propsWeight: 0,
                      tips: actType.label
                    })
                  }
                }
              }
            }

            // 等级
            let findIndex = -1
            this.tabPane.forEach((item, index) => {
              if (item.label === levelName) {
                findIndex = index
              }
            })

            if (findIndex === -1) {
              this.tabPane.push({
                label: levelName,
                min_level: val.start,
                max_level: val.end,
                bak_min_level: val.start,
                bak_max_level: val.end,
                add: true
              })
            }
            this.levelActiveName = levelName
          }
          // loading.close()
        } else {
          // loading.close()
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldType = this.actTypes[oldLevelName]
      Vue.delete(this.actTypes, oldLevelName)
      this.$set(this.actTypes, newLevelName, oldType)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addRecord(levelName, scoreName) {
      this.actType.forEach((item, index) => {
        this.formData[levelName][scoreName].data.push({
          'id': parseInt(item.value),
          'tips': item.label,
          'isShow': 0,
          'isShowBtn': 0,
          'isShowCountdown': 0,
          'iconWeight': 0,
          'position': 0,
          'propsWeight': 0
        })
      })
    },
    removeRecord(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[0].conf = this.formData[levelName][scoreName].data[0].conf.filter((item, i) => {
        return i !== index
      })
      let count = 0
      this.formData[levelName][scoreName].data[0].conf.forEach((item, index) => {
        count++
        this.formData[levelName][scoreName].data[0].conf[index].sort = count
      })
      this.listenActType(levelName, scoreName)
    },
    delEvent(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActIconSortCfgList({ id: id }).then(res => {
            if (res.code === 200) {
              this.tabPane = this.tabPane.filter(item => {
                return item.label !== levelName
              })
              this.$delete(this.formData, levelName)
              this.onSubmit(true)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup(loading = null) {
      const score = this.scoreFormData
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'id': 0,
          'data': []
        })

        // this.$set(this.actTypes[score.level_name], scoreTag, this.actType)
        // this.$set(this.visibleArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      // this.visibleArr[score.level_name][scoreTag].push({ visible: false })
      // 添加第一个元素
      this.actType.forEach((item, index) => {
        this.formData[score.level_name][scoreTag].data.push({
          'id': parseInt(item.value),
          'tips': item.label,
          'isShow': 0,
          'isShowBtn': 0,
          'isShowCountdown': 0,
          'iconWeight': 0,
          'position': 0,
          'propsWeight': 0
        })
      })

      this.activeName = score.level_name
      this.scoreFormData.group = 0
      this.scoreFormData.group_bak = 0
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
      if (loading) {
        loading.close()
      }
    },
    addLevel() {
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }
      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      // this.$set(this.visibleArr, levelName, {})
      // console.log(this.formData)
      this.$set(this.actTypes, levelName, {})

      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.scoreFormData.group = 0
      const loading = this.load()
      setTimeout(() => {
        this.addGroup(loading)
      }, 500)
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
    },
    groupChange(v, levelName, oldGroupName) {
      const newGroupName = v
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      // const oldVisible = this.visibleArr[levelName][oldGroupName]
      // this.$delete(this.visibleArr[levelName], oldGroupName)
      // this.$set(this.visibleArr[levelName], newGroupName, oldVisible)

      const oldActType = this.actTypes[levelName][oldGroupName]
      this.$delete(this.actTypes[levelName], oldGroupName)
      this.$set(this.actTypes[levelName], newGroupName, oldActType)
    },
    getActTypes() {
      getIconTypes().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.actType.push({ label: val, value: i, disabled: false })
            this.actTypeArr.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    actTypeChange(v, levelName, groupName) {
      this.listenActType(levelName, groupName)
    },
    listenActType(levelName, groupName) {
      this.actTypes[levelName][groupName].forEach((item, index) => {
        this.actTypes[levelName][groupName][index].disabled = false
      })

      this.formData[levelName][groupName].data[0].conf.forEach((item, index) => {
        for (const i in this.actTypes[levelName][groupName]) {
          const val = this.actTypes[levelName][groupName][i]
          if (val.value === item.act_type) {
            this.actTypes[levelName][groupName][i].disabled = true
            break
          }
        }
      })
    },
    exportJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportIconCfg')
    },
    // asyncOss() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     IconAsyncOss({ name: this.key }).then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    //   // window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportIconCfg')
    // },
    diffArray(item) {
      const diff = []
      for (const i in item) {
        const val = item[i]
        diff.push(parseInt(val.id))
      }
      return this.actTypeArr.filter(value => !diff.includes(value))
    }
  }
}
</script>

<style scoped>
</style>
